import React, { useRef, useState, useEffect } from 'react';
import { cn } from '../../utils/cn';

interface ScrollTextProps {
  text: string;
  className?: string;
}

const ScrollText: React.FC<ScrollTextProps> = ({ text, className }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const textRef = useRef<HTMLSpanElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    if (containerRef.current && textRef.current) {
      setIsOverflowing(textRef.current.scrollWidth > containerRef.current.clientWidth);
    }
  }, [text]);

  const duration = Math.max(3, text.length * 0.15);

  return (
    <div ref={containerRef} className={cn('overflow-hidden whitespace-nowrap group', className)}>
      <span
        ref={textRef}
        className={cn('inline-block', isOverflowing && 'group-hover:animate-scroll-left')}
        style={isOverflowing ? { animationDuration: `${duration}s` } : undefined}
      >
        {text}
      </span>
      {isOverflowing && <span className="text-gray-400 group-hover:hidden">...</span>}
    </div>
  );
};

export default ScrollText;
